module.exports = __webpack_public_path__ + "img/senior.2c4647b.png";